import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { line, curveLinearClosed } from 'd3-shape';
import { isTranspose } from '../../utils/coordinate';
import { select } from '../../utils/selection';
import { applyStyle, reorder } from '../utils';
/**
 * Adjust and return the new `points`.
 */
function getFunnelPoints(points, nextPoints, coordinate) {
  var _points = _slicedToArray(points, 4),
    p0 = _points[0],
    p1 = _points[1],
    p2 = _points[2],
    p3 = _points[3];
  if (isTranspose(coordinate)) {
    var _newP = [nextPoints ? nextPoints[0][0] : p1[0], p1[1]];
    var _newP2 = [nextPoints ? nextPoints[3][0] : p2[0], p2[1]];
    return [p0, _newP, _newP2, p3];
  }
  var newP1 = [p1[0], nextPoints ? nextPoints[0][1] : p1[1]];
  var newP2 = [p2[0], nextPoints ? nextPoints[3][1] : p2[1]];
  return [p0, newP1, newP2, p3];
}
/**
 * Render funnel in different coordinate and using color channel for stroke and fill attribute.
 */
export var Funnel = function Funnel(options, context) {
  var _options$adjustPoints = options.adjustPoints,
    adjustPoints = _options$adjustPoints === void 0 ? getFunnelPoints : _options$adjustPoints,
    style = __rest(options, ["adjustPoints"]);
  var coordinate = context.coordinate,
    document = context.document;
  return function (points, value, defaults, point2d) {
    var index = value.index;
    var defaultColor = defaults.color,
      rest = __rest(defaults, ["color"]);
    var nextPoints = point2d[index + 1];
    var funnelPoints = adjustPoints(points, nextPoints, coordinate);
    var tpShape = !!isTranspose(coordinate);
    var _ref = tpShape ? reorder(funnelPoints) : funnelPoints,
      _ref2 = _slicedToArray(_ref, 4),
      p0 = _ref2[0],
      p1 = _ref2[1],
      p2 = _ref2[2],
      p3 = _ref2[3];
    var _value$color = value.color,
      color = _value$color === void 0 ? defaultColor : _value$color,
      opacity = value.opacity;
    var b = line().curve(curveLinearClosed)([p0, p1, p2, p3]);
    return select(document.createElement('path', {})).call(applyStyle, rest).style('path', b).style('fill', color).style('fillOpacity', opacity).call(applyStyle, style).node();
  };
};
Funnel.props = {
  defaultMarker: 'square'
};